import React from 'react';
import { useNavigate } from 'react-router-dom';

interface WelcomeStepProps {
  onProtocolSelect: (protocol: 'a2a' | 'ap2' | 'mcp') => void;
}

const WelcomeStep: React.FC<WelcomeStepProps> = ({ onProtocolSelect }) => {
  const navigate = useNavigate();

  const handleProtocolSelect = (protocol: 'a2a' | 'ap2' | 'mcp' | 'mpx') => {
    if (protocol === 'mpx') {
      navigate('/channels/new/mpx');
    } else {
      onProtocolSelect(protocol);
    }
  };
  return (
    <div className="card shadow">
      <div className="card-body">
        <div className="welcome-screen">
          <h2>Add New Channel</h2>
          <p>
            Configure a new channel to enable communication through the Affinidi Trust Fabric Gateway.
            This wizard will guide you through the configuration process.
          </p>
          <p>
            <strong>First, please select the protocol type for your new channel:</strong>
          </p>

          <div className="protocol-selection">
            <button
              className="protocol-button"
              onClick={() => handleProtocolSelect('a2a')}
            >
              <div className="protocol-icon">
                <i className="fas fa-exchange-alt"></i>
              </div>
              <div className="protocol-name">A2A / UCP</div>
              <div className="protocol-description">
                Agent-to-Agent protocol for direct communication between intelligent agents, including support for UCP extensions
              </div>
            </button>

            <button
              className="protocol-button"
              onClick={() => handleProtocolSelect('ap2')}
            >
              <div className="protocol-icon">
                <i className="fas fa-exchange-alt"></i>
              </div>
              <div className="protocol-name">AP2</div>
              <div className="protocol-description">
                Agent-to-Agent Payment protocol - enhances A2A with commerce features
              </div>
            </button>

            <button
              className="protocol-button"
              onClick={() => handleProtocolSelect('mcp')}
            >
              <div className="protocol-icon">
                <i className="fas fa-plug"></i>
              </div>
              <div className="protocol-name">MCP</div>
              <div className="protocol-description">
                Model Context Protocol for connecting AI models with external data sources
              </div>
            </button>

            <button
              className="protocol-button"
              onClick={() => handleProtocolSelect('mpx')}
            >
              <div className="protocol-icon">
                <i className="fas fa-network-wired"></i>
              </div>
              <div className="protocol-name">MPX</div>
              <div className="protocol-description">
                Meeting Place brings privacy-preserving discovery and messaging between humans and agents.
                Flexible architecture for complex messaging scenarios.
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WelcomeStep;
